export default __webpack_public_path__ + "static/media/user.bb3a4325.svg";